const queries = {
  customerData: () => ['ecom-policy/customer/data'],
  policyOrderList: () => ['ecom-policy/policy-order/list'],
  shopAddressesSetup: () => ['ecom-policy/shop/setup/addresses'],
  customerHeadVendorList: (customerHeadId: number) => ['ecom-policy/vendor/list', customerHeadId],
  policyPriceList: (policyId: number, customerId?: number) => [
    'ecom-policy/policyPrices/list',
    policyId,
    customerId,
  ],
  productGroupList: () => ['ecom-policy/product-groups/list'],
  policyDetails: (policyId: number) => ['ecom-policy/policy/details', policyId],
  policyProducts: (policyId: number) => ['ecom-policy/policy/products', policyId],
  policyProductsFromWholeVendorCatalogue: (policyId: number, customerId?: number) => [
    'ecom-policy/policy/products-from-whole-vendor-catalogue',
    policyId,
    customerId,
  ],
  order: (orderId: number) => ['ecom-policy/ecom-order', orderId],
  costObjectPolicyList: (costObjectId: number) => ['ecom-policy/list', costObjectId],
  mandatoryProducts: (policyId: number, selectedProductIds: number[]) => [
    'mandatory-products',
    policyId,
    ...selectedProductIds,
  ],
  categoryClassification: () => ['ecom-policy/category-classification'],
}

export default queries
